/**
 * MicroDialogues.jsx - AI-generated conversation display component
 * Shows peer influence dynamics through simulated dialogues
 * Extracted from Analysis.jsx
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { MessageSquare } from 'lucide-react';

const MicroDialogues = ({ data }) => {
  if (!data?.has_dialogues || !data.dialogues?.length) return null;
  
  return (
    <Card data-testid="micro-dialogues">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <MessageSquare className="w-5 h-5 text-blue-500" />
          <CardTitle className="text-sm font-medium">Micro-Dialogues</CardTitle>
          <Badge variant="outline" className="text-xs bg-blue-50 text-blue-700 border-blue-200">
            {data.count} conversations
          </Badge>
        </div>
        <p className="text-xs text-muted-foreground">
          AI-generated conversations illustrating peer influence dynamics
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {data.dialogues.map((d, i) => {
            const aLabel = Object.values(d.agent_a_attrs || {}).slice(0, 2).join(', ');
            const bLabel = Object.values(d.agent_b_attrs || {}).slice(0, 2).join(', ');
            return (
              <div key={i} className="border border-slate-200 rounded-lg p-4 space-y-3 bg-slate-50/30">
                {/* Agent tags */}
                <div className="flex items-center justify-between text-[11px]">
                  <div className="flex items-center gap-4">
                    <span className="font-medium text-blue-700 bg-blue-50 px-2 py-0.5 rounded">
                      A: {aLabel}
                    </span>
                    <span className="text-muted-foreground">{d.a_initial} → {d.a_final}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="font-medium text-blue-700 bg-blue-50 px-2 py-0.5 rounded">
                      B: {bLabel}
                    </span>
                    <span className="text-muted-foreground">{d.b_initial} → {d.b_final}</span>
                  </div>
                </div>
                {/* Dialogue text */}
                <div className="text-sm text-slate-700 whitespace-pre-line leading-relaxed pl-3 border-l-2 border-blue-200">
                  {d.dialogue}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default MicroDialogues;
